import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessionService {

  constructor(private http: HttpClient) { }

    getAllProfessionList(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');

        let urlGetAllNews = environment.apiURL + environment.adminApiUrl + environment.getProfessionUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllNews)
        
    }
      
    updateProfessions(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateProfessionUrl, postObj,httpOptions);
    }
          
    insertProfession(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertProfessionUrl, postObj,httpOptions);
    } 

    getProfession( id: any) : Observable<any> {
      
        if(id){

        }
        else {
            id = 1;
        }

        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getProfessionUrl+"/" + id);
    }
    deleteProfession(postObj:any) : Observable<any> {

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteProfessionUrl, postObj,httpOptions);
    }




    /*========================= 
    Blog Category
    ========================== */


    getAllBlogsCategory(filterObj,start,limit){

        let urlGetAllNews = environment.apiURL + environment.adminApiUrl + environment.getBlogsCategoryUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllNews)
        
    }
      
    updateBlogsCategory(postObj:any) : Observable<any> {

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateBlogsCategoryUrl, postObj,httpOptions);
    }
          
    insertBlogsCategory(postObj:any) : Observable<any> {

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertBlogsCategoryUrl, postObj,httpOptions);
    } 

    getBlogsCategory( id: any) : Observable<any> {
      
        if(id){

        }
        else {
            id = 1;
        }

        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getBlogsCategoryUrl+"/" + id);
    }

    deleteBlogsCategory(postObj:any) : Observable<any> {

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteBlogCategorysUrl, postObj,httpOptions);
    }

}
